import React from 'react';
import './documentUpload.scss';
type DocumentsType = {
  // waec: File | string;
  // waec2: any;
  // gce: File | string;
  // gce2: any;
  // neco: File | string;
  // neco2: any;
  // nabteb: File | string;
  // nabteb2: any;
  ssce: File | string;
  ssce2: File | string;
  birthCertificate: File | string;
  lgaCertificate: File | string;
  professionalCertificate: File | string;
  educationalCertificate: File | string;
}
interface DocumentsUploadProps {
    ninValidated: boolean;
    boxErrorMessage: string;
    displayForm: boolean;
    validateFormRow: () => boolean;
    setSittings: (sittings: number) => void;
    getDocumentsUploadProgress: () => number;
    currentDocument: string;
    changeCurrentDocument: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    sittings: number;
    documentError: string;
    radioForm: string;
    getRootProps: () => any;
    getInputProps: () => any;
    selectMaster: any;
    isDragActive: boolean;
    documents: { [key: string]: string };
    documentsMapper: (key: string) => string;
    removeDocument: (key: string) => void;
    manifestInfo: any
}

export default function DocumentUpload (props: DocumentsUploadProps) {
  // const twoSittings = props.sittings === 2 ? 2 : 1;
  // const lenObj = Object.entries(props.manifestInfo).filter(([key, data]: any) => data?.upload === false).length;
  // console.log('manifest info length:', lenObj);
  // console.log(props.manifestInfo.ssce.upload);
  const [twoSittings, setTwoSittings] = React.useState<boolean>(false);
  return (
    <div>
      {' '}
      <section
        className={` border-0 rounded${
          !props.ninValidated || props.boxErrorMessage ? ' d-none' : ''
        } ${props.validateFormRow() === false && 'd-none'} ${
          !props.displayForm ? ' d-none' : 'd-block'
        }`}
        id='doc'
      >
        { <div className='bg-white'>
          <div className='section-container'>
            <div className='section-item-container'></div>
            <div className='section-item-container p-1'>
              <h3 className='sub-heading__pinfo'>SSCE Information</h3>
            </div>
            <div className='section-item-container'></div>
          </div>
          <div className='row m-0 p-0'>
            <div className='col-md-6 offset-md-3 p-3 bg-white'>
              <div className='d-flex'>
              <div className='col-md-5'>
              Are you using two sittings for your ssce?
              </div>
              <div
          className={`toggle-switch ${twoSittings ? 'active' : ''} col-md-1`}
          onClick={() => { setTwoSittings(!twoSittings); props.setSittings(!twoSittings ? 2 : 1) }}
        >
          <div className="toggle-knob" />
        </div>
        </div>
              {/* <div className='col-md-12 p-2'>
                {props.getDocumentsUploadProgress() === 100
                  ? 'File attachment completed'
                  : 'File attachment in progress'}
                <div className='progress'>
                  <div
                    className={`progress-bar ${
                      props.getDocumentsUploadProgress() === 100
                        ? 'bg-success'
                        : 'bg-warning'
                    }`}
                    role='progressbar'
                    style={{
                      width: props.getDocumentsUploadProgress() + '%',
                    }}
                    aria-valuenow={props.getDocumentsUploadProgress()}
                  >
                    {`${props.getDocumentsUploadProgress()}%`}
                  </div>
                </div>
              </div> */}
              <div className='form-group col-md-12 padleft d-none'>
                <small className='text-danger'>
                  NB: Maximum of two(2) OLevel sittings are allowed. Ensure you
                  upload a well scanned document. A pooly scanned document with
                  low resolution is not verifiable.
                </small>
                {/* <small className='text-danger'>
                 image size must not be greater than 2mb
                </small> */}
                <label className='control-label' htmlFor='gender'>
                  Choose a document type to upload(.jpg only) | <span className='text-danger'>max-size: 2mb</span>
                  <span id='compulsory'>*</span>
                </label>
                <div className='input-group'>
                  <div className='input-group-prepend'>
                    <div className='input-group-text'>
                      <i className='fa fa-file text-default'></i>
                    </div>
                  </div>
                  <select
                    className='form-control d-none'
                    value={props.currentDocument}
                    onChange={(e) => props.changeCurrentDocument(e)}
                    // disabled={props.sittings === 1}
                  >
                    <option value=''> -- choose file type to upload -- </option>
                    <optgroup label='Required Documents'>
                      {!props.manifestInfo?.birthCertificate?.upload && <option value='birthCertificate'>
                        Birth Certificate/Age Declaration
                      </option>}
                      {!props.manifestInfo?.lgaCertificate?.upload && <option value='lgaCertificate'>
                        LGA certificate
                      </option>}
                      {!props.manifestInfo?.professionalCertificate?.upload && props.radioForm && (props.radioForm === 'spc' || props.radioForm === 'sp-asp2-insp2' || props.radioForm === 'sp-asp-insp')
                        ? (
                        <option value='professionalCertificate'>
                          Professional Certificate
                        </option>
                          )
                        : (
                            ''
                          )}
                    </optgroup>
                    {((!props.manifestInfo?.ssce?.upload) || (props.manifestInfo?.ssce1?.upload && !props.manifestInfo?.ssce1?.upload) || (twoSittings && !props.manifestInfo?.ssce2?.upload)) &&
                    <optgroup label='SSCE Certificate'>
                      <option value='waec'>WAEC</option>
                      <option value='gce'>GCE</option>
                      <option value='neco'>NECO</option>
                      <option value='nabteb'>NABTEB</option>
                    </optgroup>}
                    {(props.radioForm !== 'gdc' && props.radioForm !== 'spc') && <optgroup label='First Degree'>
                      <option value='hnd'>HND</option>
                      <option value='bsc'>BSC</option>
                    </optgroup>}
                    {(props.radioForm !== 'gdc' && props.radioForm !== 'spc' && props.selectMaster === 'MSC') && <optgroup label='Master Degree'>
                      <option value='msc'>MSC</option>
                    </optgroup>}
                      {(props.radioForm !== 'gdc' && props.radioForm !== 'spc') && <optgroup label='Other Degree'>
                      <option value='other-degree'>others</option>
                    </optgroup>}
                    {(props.radioForm !== 'gdc' && props.radioForm !== 'spc') && <optgroup label='Resume'>
                      <option value='resume'>Resume</option>
                    </optgroup>}
                      {(props.radioForm !== 'gdc' && props.radioForm !== 'spc') && <optgroup label='Signature'>
                      <option value='signature'>Signature</option>
                    </optgroup>}
                  </select>
                </div>
                <small className='error-value'>{props.documentError}</small>
              </div>
              <div className='form-group col-md-12 d-none '>
                {props.currentDocument && (
                  <div
                    className='image-upload-wrap w-100 animate__animated animate__fadeIn'
                    {...props.getRootProps()}
                  >
                    <input
                      className='file-upload-input'
                      type='file'
                      accept=".jpg, .jpeg, image/jpeg"
                      {...props.getInputProps()}
                    />
                    <div className='drag-text'>
                      {props.isDragActive
                        ? (
                        <h3 className='h33'>Drop the file</h3>
                          )
                        : (
                        <h3 className='h33'>
                          Click here to upload a file or Drag and drop a file
                        </h3>
                          )}
                    </div>
                  </div>
                )}
              </div>
              <div className='col-md-12'>
                {Object.keys(props.documents).map(
                  (key: string, index: number) => {
                    if (props.documents[key as keyof DocumentsType] !== '') {
                      return (
                        <span
                          key={index}
                          className='upload-pill animate__animated animate__zoomIn'
                        >
                          <button
                            onClick={() => props.removeDocument(key)}
                            className='p-0 btn btn-success m-1'
                          >
                            {props.documentsMapper(key)}{' '}
                            <i className='fa fa-times fa-1x btn-progress m-0 text-white cancel'></i>
                          </button>
                        </span>
                      );
                    }
                    return null;
                  }
                )}
              </div>
            </div>
          </div>
        </div>}
      </section>
    </div>
  );
}
